<template>
<div>
    <div>

    </div>
</div>
</template>

<script>
    export default {
        name: "login",
        data() {
            return {

            };
        },
        methods: {

        },
        created() {
            sessionStorage.removeItem('token');
            let href = location.href;
            if (href.includes("//login")) {
                let url = href.substring(0, href.indexOf('#'));
                let jingPosit = url.indexOf("//login"); //获取域名结束的位置
                let urlLeft = url.substring(0, jingPosit);//url左侧部分
                let urlRight = url.substring(jingPosit+1, url.length); //url右侧部分
                let redirect = urlLeft+"/#" + urlRight;
               location.href = redirect//拼接跳转
            }
            if(this.$route.query.appid){
                sessionStorage.setItem('appid',this.$route.query.appid)
            }
            if(process.env.NODE_ENV=='development'){
                sessionStorage.setItem('token',process.env.OPENID_ENV)
                this.$router.push({path:'/'})
                return false;
            }

            let code = this.$route.query.code;
            let openid = this.$route.query.openid
            let url = encodeURIComponent(location.href.replace("#",''));
            if (!code) {
                this.fetchData('/wechat/authUrl', {url: url,openid:openid}, (res) => {
                    this.$toast.clear();
                    if (res.code) {
                        location.href = res.url;
                    } else {
                        this.$toast.fail(res.msg)
                    }
                })
            }
            if (code) {
                this.fetchData('/wechat/getopenid', {code: code,openid:openid,url:url}, (res) => {
                    this.$toast.clear();
                    if (res.code) {
                        if(res.url){
                            location.href = res.url;
                        }else {
                            sessionStorage.setItem('token', res.data);
                            let query = this.$route.query
                            let path = query.path
                            if (!path) path = '/';
                            query.code = undefined
                            query.path = undefined
                            query.auto = 1;
                            this.$router.push({path: path, query: query})
                        }
                    } else {
                        this.$toast.fail(res.msg)
                        //this.$router.push({path:'/'})
                    }
                })
            }
        },
    };
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/login.vue